module.exports = __webpack_public_path__ + "static/media/success-graphic.536b975f.svg";